<template>
  <div>
    <common-dialog ref="dialog" width="100%" :unit="StageName + '工单'" id-key="UserId" :get-data-func="api.info" @details-opened="detailsOpened" @close-saved="$emit('close-saved')">
      <div style="margin-bottom: 18px">产品明细</div>

      <el-table ref="list2" :data="CombinationBom" class="table_bottom table-line tb-c-head" border>
        <el-table-column prop="ProductNo" label="产品编码" min-width="120"></el-table-column>
        <el-table-column prop="ProductName" label="产品名称" min-width="120">
          <template slot-scope="{ row, $index }">
            <span v-if="Status >= 3">{{ row.ProductName }}</span>
            <account-select
              v-else
              v-model="row.ProductName"
              :source="pDAccount"
              @select="onSelect($event, row, $index, 1)"
              :pageSize="ppageParams.pageSize"
              :pageIndex="ppageParams.pageIndex"
              :listTotal="plistTotal"
              @inputText="pinputText"
              @click.native="presetFun"
              @currentPage="pcurrentPage"
              :pageType="true"
              keyword="ProductName"
            />
          </template>
        </el-table-column>
        <el-table-column prop="ProductSpec" label="规格" min-width="120"></el-table-column>
        <el-table-column prop="BatchNumber" label="批号" min-width="120"></el-table-column>
        <el-table-column prop="BarCode" label="存货条码" min-width="120"></el-table-column>
        <el-table-column prop="PropertyName" label="属性" min-width="120">
          <template slot-scope="{ row }">
            <el-select filterable v-if="Status < 3" v-model="row.PropertyId" v-show="row.UseProcess" @change="changeProperty($event, row)">
              <el-option v-for="item in propertyList" :key="item.PropertyId" :value="item.PropertyId" :label="item.PropertyName"></el-option>
            </el-select>
            <span v-else>{{ row.PropertyName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ColorId" label="颜色" min-width="120">
          <template slot-scope="{ row }">
            <el-select filterable v-model="row.ColorId" @change="changeColor($event, row, 1)" v-show="row.UseColor" v-if="Status < 3">
              <el-option v-for="item in row.Colors" :key="item.ColorId" :value="item.ColorId" :label="item.ColorName"></el-option>
            </el-select>
            <span v-else>{{ row.ColorName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="TrademarkNo" label="商标" min-width="120">
          <template slot-scope="{ row }">
            <account-select
              v-if="Status < 3"
              v-model="row.TrademarkNo"
              :source="MarkAccount"
              :Head="MarkHead"
              @select="onMarkSelect($event, row)"
              :pageSize="pageMarkParams.pageSize"
              :pageIndex="pageMarkParams.pageIndex"
              :listTotal="listMarkTotal"
              @inputText="inputMarkText"
              @click.native="resetMarkFun(row)"
              @currentPage="currentMarkPage($event, row)"
              :pageType="true"
              :clearable="true"
              :isShowClear="true"
              @clear="onMarkClear(row)"
            />
            <span v-else>{{ row.TrademarkNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="PdUnitName" label="单位" min-width="120"></el-table-column>
        <el-table-column prop="Quantity" label="需求数量" min-width="120">
          <template slot-scope="{ row }">
            <span v-if="Status >= 3">{{ $commonJs.toThousands(row.Quantity) }}</span>
            <el-input v-else clearable v-model="row.Quantity" @change="changeQua($event, row, 1)" placeholder="请输入数量" type="number" />
          </template>
        </el-table-column>
        <el-table-column prop="ImgUrl" label="图片" min-width="120">
          <template slot-scope="{ row }">
            <el-button type="text" @click="viewImg(row)">{{ row.ProductId ? '查看' : '' }} </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="ProcessStageName" label="加工阶段" min-width="120"> </el-table-column>
        <el-table-column prop="ProduceTypeName" label="存货类型" min-width="120"></el-table-column>

        <el-table-column prop="Quantity" label="生产数量" min-width="120">
          <template slot-scope="{ row }">
            <!-- <span>{{
              row.Quantity - (row.StockQuantity ?? 0) < 0
                ? 0
                : row.Quantity - (row.StockQuantity ?? 0)
            }}</span> -->
            <span>{{ row.Quantity }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="PickingWarehouseId" label="预入仓" min-width="120">
          <template slot-scope="{ row }">
            <el-select v-model="row.PickingWarehouseId" :disabled="Status >= 3" @change="onWarehouse(row)">
              <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="PickingWarehousePositionId" label="预入库位" min-width="120">
          <template slot-scope="{ row }">
            <el-select :disabled="Status >= 3" v-model="row.PickingWarehousePositionId" @visible-change="onChangeWarehousePosition($event, row, row.PickingWarehouseId)">
              <el-option v-for="item in row.WarehousePositionList" :key="item.WarehouseId" :label="item.WarehousePositionName" :value="item.WarehousePositionId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="SchedulingType" label="排产类型" min-width="120" key="column1" v-if="!QuickProcess">
          <template slot-scope="{ row }">
            <el-select v-show="!QuickProcess" v-model="row.SchedulingType" @change="changeSchedulingType($event, row)" :disabled="Status >= 3">
              <el-option key="SchedulingType1" label="部门" :value="0"></el-option>
              <!-- <el-option key="SchedulingType2" label="设备" :value="1"></el-option> -->
            </el-select>
          </template>
        </el-table-column>

        <!-- <el-table-column
          label="加工部门/设备"
          min-width="120"
          key="column2"
          v-if="!QuickProcess"
        >
          <template slot-scope="{ row }">
            <dp-select
              v-if="row.SchedulingType === 0"
              style="width: 180px"
              @input="editT(row)"
              :disabled="Status >= 3"
              v-model="row.DpId"
              v-show="!QuickProcess"
            />
            <el-select
              v-else
              style="width: 180px"
              @input="editT(row)"
              :disabled="Status >= 3"
              v-model="row.MaintenanceId"
              v-show="!QuickProcess"
            >
              <el-option
                v-for="item in equipmentList"
                :key="item.EquipmentId"
                :label="item.EquipmentName"
                :value="item.EquipmentId"
              ></el-option>
            </el-select>
          </template>
        </el-table-column> -->
        <el-table-column label="生产部门" min-width="120" key="column2">
          <template slot-scope="{ row }">
            <dp-select v-show="row.ProductionType == 0" style="width: 180px" :disabled="Status >= 3" v-model="row.DpId" />
          </template>
        </el-table-column>
        <el-table-column prop="ProductionType" label="生产类型" min-width="120">
          <template slot-scope="{ row }">
            <el-select @change="editT(row)" v-model="row.ProductionType" :disabled="Status >= 3">
              <el-option key="ProductionType1" label="自产" :value="0" v-if="row.ProductNature == 2 || row.ProductNature == 0"></el-option>
              <el-option key="ProductionType2" label="委外" :value="1" v-if="row.ProductNature == 2 || row.ProductNature == 1"></el-option>
              <!-- <el-option key="ProductionType3" label="自产&委外" :value="2"></el-option> -->
            </el-select>
          </template>
        </el-table-column>

        <el-table-column prop="ProductionDpId" label="加工商" min-width="120">
          <template slot-scope="{ row }">
            <!-- <el-select v-model="row.ProductionDpId"  @change="editT(row)" :disabled="Status === 1 || row.ProductionType !== 1"> -->
            <el-select v-model="row.ProductionDpId" @change="editT(row)" v-show="row.ProductionType == 1" :disabled="Status >= 3">
              <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :label="item.FullName" :value="item.TradeUnitId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="StartTime" label="开始日期" min-width="120">
          <template slot-scope="{ row }">
            <span v-if="Status >= 3">{{ row.StartTime }}</span>
            <el-date-picker v-else v-model="row.StartTime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"> </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column prop="DocDate" label="单据日期" min-width="120">
          <template slot-scope="{ row }">
            <span v-if="Status >= 3">{{ $commonJs.toDateString(row.DocDate) }}</span>
            <el-date-picker v-else v-model="row.DocDate" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date" placeholder="选择日期" @change="dateChange($event, row, 'DocDate')">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column prop="EndTime" label="完工日期" min-width="200">
          <template slot-scope="{ row }">
            <span v-if="Status >= 3">{{ row.EndTime }}</span>
            <el-date-picker
              v-else
              v-model="row.EndTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              type="date"
              placeholder="选择日期"
              @change="dateChange($event, row, 'EndTime')"
            >
            </el-date-picker>
          </template>
        </el-table-column>

        <el-table-column prop="Remark" label="工单备注" min-width="200">
          <template slot-scope="{ row }">
            <span v-if="Status >= 3">{{ row.Remark }}</span>
            <el-input v-else v-model="row.Remark" type="text" @change="editT(row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="Bomno" label="BOM版本号" min-width="120"></el-table-column>
        <el-table-column label="设计图" prop="PdImgs" align="center" min-width="100">
          <template slot-scope="{ row }">
            <el-button v-if="Status < 3" type="text" @click="uploadImg(row)">上传</el-button>
            <el-button v-else type="text" @click="viewImg2(row)">{{ row.PdImgs != null ? '查看' : '' }} </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-tabs v-model="activeName" type="card" style="margin-top: 18px">
        <el-tab-pane label="工艺方案" name="tab1">
          <div class="flex1">
            <div class="flex2">
              <div class="mr8">{{ currentProgrammeName }}</div>
              <el-button type="primary" :disabled="Status >= 3" @click="changeProgramme" key="btn1">选择方案</el-button>
            </div>
          </div>
          <el-table :data="ProcessModels.length === 0 ? [] : ProcessModels[0].Processes" class="table_bottom table-line tb-c-head" border ref="list3">
            <el-table-column prop="ProcessId" label="工序名称" min-width="120">
              <template slot-scope="{ row }">
                <el-select v-model="row.ProcessId" :disabled="Status >= 3">
                  <el-option v-for="(item, index) in teProcessList" :key="index" :value="item.ProcessId" :label="item.ProcessName"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="ProductionType" label="自制工序或者委外工序" min-width="120">
              <template slot-scope="{ row }">
                <el-select v-model="row.ProcessType" :disabled="Status >= 3" @change="changeProcessType($event, row)">
                  <el-option key="a1" label="自制工序" :value="0"></el-option>
                  <el-option key="a2" label="委外工序" :value="1"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="TradeUnitId" label="委外供应商" min-width="120">
              <template slot-scope="{ row }">
                <div class="flex" v-show="row.ProcessType === 1">
                  <el-input type="text" v-model="row.TradeUnitName" readonly :disabled="Status >= 3" />
                  <el-button type="primary" @click="selectCome(row)" :disabled="Status >= 3" key="btn2">选择</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="材料明细" name="tab2">
          <div class="flex-content">
            <el-button type="primary" @click="add" v-if="Status < 3">添加</el-button>
          </div>
          <el-table :data="DetailModels" class="table_bottom table-line tb-c-head" border>
            <el-table-column prop="ProductNo" label="子件编码" min-width="120"></el-table-column>
            <el-table-column prop="ProductName" label="子件名称" min-width="120">
              <template slot-scope="{ row, $index }">
                <span v-if="Status >= 3">{{ row.ProductName }}</span>
                <account-select
                  v-else
                  v-model="row.ProductName"
                  :source="DAccount"
                  @select="onSelect($event, row, $index)"
                  :pageSize="pageParams.pageSize"
                  :pageIndex="pageParams.pageIndex"
                  :listTotal="listTotal"
                  @inputText="inputText"
                  @click.native="resetFun"
                  @currentPage="currentPage"
                  :pageType="true"
                  keyword="ProductName"
                />
              </template>
            </el-table-column>
            <el-table-column prop="ProductSpec" label="规格" min-width="120"></el-table-column>
            <el-table-column prop="BatchNumber" label="批号" min-width="120"></el-table-column>
            <el-table-column prop="PdUnitName" label="单位" min-width="120"></el-table-column>
            <el-table-column prop="PropertyName" label="属性" min-width="120">
              <template slot-scope="{ row }">
                <el-select filterable v-if="Status < 3" v-model="row.Property" v-show="row.UseProcess" @change="changeProperty($event, row)">
                  <el-option v-for="item in propertyList" :key="item.PropertyId" :value="item.PropertyId" :label="item.PropertyName"></el-option>
                </el-select>
                <span v-else>{{ row.PropertyName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ColorId" label="颜色" min-width="120">
              <template slot-scope="{ row }">
                <el-select filterable v-model="row.ColorId" @change="changeColor($event, row)" v-show="row.UseColor" v-if="Status < 3">
                  <el-option v-for="item in row.Colors" :key="item.ColorId" :value="item.ColorId" :label="item.ColorName"></el-option>
                </el-select>
                <span v-else>{{ row.ColorName }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="Quantity" label="需求数量" min-width="120">
              <template slot-scope="{ row }">
                <span v-if="Status >= 3">{{ $commonJs.toThousands(row.Quantity) }}</span>
                <el-input v-else clearable v-model="row.Quantity" placeholder="请输入数量" @change="changeQua($event, row)" type="number" />
              </template>
            </el-table-column>
            <el-table-column prop="OutWarehouseId" label="预出仓" min-width="120">
              <template slot-scope="{ row }">
                <el-select v-model="row.OutWarehouseId" :disabled="Status >= 3" @change="changeOutWarehouse(row)">
                  <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="OutWarehousePositionId" label="预出库位" min-width="120">
              <template slot-scope="{ row }">
                <div v-if="!row.OutWarehouseId">请先填写预出仓</div>
                <el-select v-else v-model="row.OutWarehousePositionId" @visible-change="onChangeWarehousePosition($event, row, row.OutWarehouseId)">
                  <el-option v-for="item in row.WarehousePositionList" :key="item.WarehouseId" :label="item.WarehousePositionName" :value="item.WarehousePositionId"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="ImgUrl" label="图片" min-width="120">
              <template slot-scope="{ row }">
                <el-button type="text" @click="viewImg(row)">{{ row.ProductId ? '查看' : '' }} </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="Remarks" label="备注" />
            <el-table-column prop="ProcessStageName" label="加工阶段" min-width="120"> </el-table-column>

            <el-table-column prop="ProduceTypeName" label="存货类型" min-width="120"> </el-table-column>
            <el-table-column label="操作" fixed="right" align="center" width="80" v-if="Status < 3">
              <template slot-scope="{ row, $index }">
                <el-button type="text" @click="del(row, $index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>

      <template slot="footer">
        <el-button type="primary" @click="save" v-if="Status < 3">保存</el-button>
        <el-button type="primary" @click="onPrint" v-if="this.$parent.orderType == '已下达' || this.$parent.orderType == '日生产'">打印</el-button>
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
    <detail-dialog ref="detailDialog" @saved="detail_saved" :disabled="Status === 3"></detail-dialog>
    <list-dialog ref="listDialog" selectable :multiple="false" @select="listDialogSelect"></list-dialog>
    <come-list-dialog @select="comeSelect" selectable :multiple="false" ref="comeListDialog" in-dialog />
    <img-dialog ref="imgDialog" :imgs="imgs" />
    <bom-pd-img-dialog ref="bomPdImgDialog" @saved="img_saved" />
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import accountSelect from '@/components/production/clothmanagement/cloth/select'
import dpSelect from '@/components/production/clothmanagement/cloth/workorder/dpSelect'
import { urlHttp } from '@/components/production/clothmanagement/cloth/workorder/bomConfig'
import imgDialog from '@/components/production/clothmanagement/cloth/workorder/imgDialog'
import detailDialog from '@/components/production/clothmanagement/cloth/workorder/detailDialog'
import vSelect from '@/components/production/clothmanagement/cloth/workorder/vSelect'
import listDialog from '@/components/production/craftsmanship/solutions/assembly/listDialog'
import comeListDialog from '@/components/basedata/business/come/listDialog'
import bomPdImgDialog from '@/components/production/craftsmanship/bom/bomPdImgDialog'

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    accountSelect,
    dpSelect,
    imgDialog,
    vSelect,
    detailDialog,
    listDialog,
    comeListDialog,
    bomPdImgDialog
  },
  props: {
    Stage: {
      type: Number,
      default: 0
    },
    StageName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeName: 'tab1',
      currentProgrammeName: '',
      api: require('@/api/production/workDoc').default,
      pdApi: require('@/api/ba/product').default, // product是产品 到时换成模具API
      warehousePositionApi: require('@/api/ba/warehousePosition').default,
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      Head: [
        { Value: 'ProductNo', Name: '产品编码', Width: '180' },
        { Value: 'ProductName', Name: '产品名称', Width: '180' }
      ],
      pinitDAccount: [],
      pinitTotal: 0,
      pDAccount: [],
      plistTotal: 0,
      ppageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      Status: 0,
      imgs: [],
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      tradeUnitList: [],
      propertyApi: require('@/api/ba/property').default,
      propertyList: [],
      equipmentApi: require('@/api/ba/equipment').default,
      equipmentList: [],
      optionApi: require('@/api/sy/option').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      warehouseList: [],
      QuickProcess: false, // 是否启动快捷方式
      IsSelfPicking: true, // 是否启用自制工单领料
      CombinationBom: [
        {
          T: 0,
          WorkDocId: 0,
          WorkDocNo: '',
          WorkDocProductId: 0,
          ProductId: 0,
          ProductNo: '',
          ProductName: '',
          ProductSpec: '',
          BatchNumber: '',
          PdUnitId: 0,
          PdUnitName: '',
          ColorId: 0,
          Quantity: 0,
          ImgUrl: '',
          ProcessStage: 0,
          ProduceTypeName: '',
          SchedulingType: null,
          DpId: 0,
          MaintenanceId: 0,
          ProductionType: '',
          ProductionDpId: 0,
          Remark: '',
          ProgrammeId: 0,
          OrderProductNo: '',
          DocDate: this.$commonJs.getToday(),
          StartTime: this.$commonJs.getToday(),
          EndTime: this.$commonJs.getToday(),
          PickingWarehouseId: null,
          PickingWarehousePositionName: null,
          PickingWarehousePositionId: null,
          PickingWarehousePositionIdName: null,
          WarehousePositionList: [],
          PdImgs: []
        }
      ],
      ProcessModels: [
        {
          ProductName: '',
          ProductNo: '',
          ProgrammeName: '',
          ProgrammeId: 0,
          Processes: []
        }
      ],
      DetailModels: [
        {
          T: 0,
          WorkDocId: 0,
          WorkDocNo: '',
          WorkDocMaterialId: 0,
          ProductId: 0,
          ProductNo: '',
          ProductName: '',
          ProductSpec: '',
          BatchNumber: '',
          PdUnitId: 0,
          PdUnitName: '',
          Property: '',
          PropertyName: '',
          Quantity: 0,
          ImgUrl: '',
          ProcessStage: 0,
          ProduceTypeName: '',
          ColorId: 0,
          ColorName: '',
          Colors: [],
          UseProcess: true,
          UseColor: true,
          MouldNo: '',
          MouldId: 0,
          MouldName: '',
          Rate: 0,
          Loss: 0,
          Ration: 0,
          RationUnit: 0,
          OutWarehousePositionId: null,
          WarehousePositionList: []
        }
      ],
      programmeCurrentRow: null,
      delDetailModels: [],
      ProcessRow: null,
      teProcessApi: require('@/api/production/teProcess').default,
      trademarkApi: require('@/api/ba/trademark').default,
      teProcessList: [],
      delProcess: [],
      MarkAccount: [],
      initMarkAccount: [],
      initMarkTotal: 0,
      listMarkTotal: 0,
      pageMarkParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      MarkHead: [
        { Value: 'TrademarkNo', Name: '商标编码', Width: '150' },
        { Value: 'TrademarkName', Name: '商标名称', Width: '150' }
      ]
    }
  },
  created() {
    this.optionApi.getProductSetting().then(res => {
      if (res.Code === 0) {
        this.QuickProcess = res.Data.QuickProcess
      }
    })

    this.optionApi.getInitialSetting().then(res => {
      if (res.Code === 0) {
        this.IsSelfPicking = res.Data.IsSelfPicking
      }
    })
    this.warehouseApi.list({}).then(res => {
      if (res.Code === 0) {
        this.warehouseList = res.Data
      }
    })

    this.pdApi
      .list({
        ProcessStages: [this.Stage],
        Status: 1,
        pageSize: this.ppageParams.pageSize,
        pageIndex: this.ppageParams.pageIndex
      })
      .then(res => {
        if (res.Code === 0) {
          console.log('productApi res.Data', res.Data)
          this.pDAccount = res.Data
          this.pinitDAccount = res.Data
          this.plistTotal = res.Count
          this.pinitTotal = res.Count
        }
      })

    this.pdApi
      .list({
        //ProcessStages: [0, 1, 2],
        Status: 1,
        pageSize: this.pageParams.pageSize,
        pageIndex: this.pageParams.pageIndex
      })
      .then(res => {
        if (res.Code === 0) {
          console.log('productApi res.Data', res.Data)
          this.DAccount = res.Data
          this.initDAccount = res.Data
          this.listTotal = res.Count
          this.initTotal = res.Count
        }
      })
    // this.pdApi.list({}).then(res => {

    //   let data1 =  res.Data.filter(item => {
    //     return item.ProcessStage === 3
    //   })

    //   this.pDAccount = data1;
    //   this.pinitDAccount = data1;
    //   this.plistTotal = data1.length;
    //   this.pinitTotal = data1.length;

    //   let data2 =  res.Data.filter(item => {
    //     return item.ProcessStage !== 3 && item.ProcessStage !== 4
    //   })

    //   this.DAccount = data2;
    //   this.initDAccount = data2;
    //   this.listTotal = data2.length;
    //   this.initTotal = data2.length;

    // })

    this.equipmentApi.list({ Statuses: [1, 2] }).then(res => {
      if (res.Code === 0) {
        this.equipmentList = res.Data
      }
    })
    this.tradeUnitApi.list({ TradeUnitType: 3, Status: 1 }).then(res => {
      if (res.Code === 0) {
        this.tradeUnitList = res.Data
      }
    })

    this.propertyApi.list({ Status: 1 }).then(res => {
      if (res.Code === 0) {
        this.propertyList = res.Data
      }
    })

    this.teProcessApi.list({}).then(res => {
      if (res.Code === 0) {
        this.teProcessList = res.Data

        console.log('====this.teProcessList ====', this.teProcessList)
      }
    })
    this.trademarkApi.list({ Status: 1, pageSize: 7, pageIndex: 1 }).then(res => {
      if (res.Code == 0) {
        this.initMarkAccount = res.Data
        this.MarkAccount = res.Data
        this.initMarkTotal = res.Count
        this.listMarkTotal = res.Count
      }
    })
  },
  methods: {
    onMarkClear(row) {
      row.TrademarkId = null
      row.TrademarkName = ''
      row.TrademarkNo = ''
    },
    onMarkSelect(val, row) {
      console.log(val, row, 'onMarkSelect')
      if (val) {
        row.TrademarkId = val.TrademarkId
        row.TrademarkName = val.TrademarkName
        row.TrademarkNo = val.TrademarkNo
        if (val.TrademarkPhoto) {
          var photos = val.TrademarkPhoto.split(',')
          photos.forEach(item => {
            row.PdImgs.push({ url: '/api' + item, url2: item, T: 0, WorkDocProductId: 0, ProductImgId: 0, ImgType: 2 })
          })
        }
      }
    },
    resetMarkFun(row) {
      this.pageMarkParams.pageIndex = 1
      this.MarkAccount = this.initMarkAccount
      this.listMarkTotal = this.initMarkTotal

      let param = { pageIndex: 1, pageSize: 7, Status: 1 }

      this.trademarkApi.list(param).then(res => {
        if (res.Code == 0) {
          this.MarkAccount = res.Data
          this.listMarkTotal = res.Count
        }
      })
    },
    currentMarkPage({ val, text1 }, row) {
      console.log(val, text1, row)
      this.pageMarkParams.pageIndex = val

      let param = { pageIndex: val, pageSize: 7, Status: 1, TrademarkName: text1 }

      this.trademarkApi.list(param).then(res => {
        if (res.Code == 0) {
          this.MarkAccount = res.Data
          this.listMarkTotal = res.Count
        }
      })
    },
    inputMarkText(text) {
      this.trademarkApi
        .list({
          PageIndex: 1,
          PageSize: 7,
          TrademarkName: text,
          Status: 1
        })
        .then(res => {
          if (res.Code == 0) {
            this.MarkAccount = res.Data
            this.listMarkTotal = res.Count
          }
        })
    },
    img_saved(data, removeData, row) {
      console.log(data, removeData, row, 'img_saved')
      if (data) {
        console.log(data, removeData, row, 'img_saved2')
        var imgs = []
        data.forEach(item => {
          imgs.push({ WorkDocProductId: row.WorkDocProductId, ImgUrl: item.url2, T: item.T, ProductImgId: item.ProductImgId, ImgType: item.ImgType })
        })
        if (removeData.length > 0) {
          removeData.forEach(item => {
            imgs.push({ WorkDocProductId: row.WorkDocProductId, ImgUrl: item.url2, T: 2, ProductImgId: item.ProductImgId, ImgType: item.ImgType })
          })
        }
        row.PdImgs = imgs
        this.$set(row, 'PdImgs', row.PdImgs)
        console.log(row, this.CombinationBom, 'row')
      }
    },
    uploadImg(row) {
      console.log(row, this.CombinationBom, 'row')
      if (row.WorkDocProductId > 0) {
        this.$refs.bomPdImgDialog.openEdit(row)
      } else {
        this.$refs.bomPdImgDialog.openCreate(row)
      }
    },
    /** 预入出仓库 切换时 赋值预入库位 */
    onWarehouse(row) {
      row.PickingWarehousePositionId = null
    },

    async onChangeWarehousePosition(e, row, id) {
      if (row.T !== 0) {
        row.T = 1
      }
      if (e) {
        const o = { Status: 1, WarehouseId: id }
        const res = await this.warehousePositionApi.list(o)

        const list = res.Data.map(item => {
          return {
            WarehousePositionId: item.WarehousePositionId,
            WarehousePositionName: item.WarehousePositionName
          }
        })
        this.$set(row, 'WarehousePositionList', list)
        this.$forceUpdate()
        console.log('row.WarehousePositionList', row.WarehousePositionList)
      }
    },
    changeOutWarehouse(row) {
      this.editT(row)
      row.OutWarehousePositionId = null
    },
    close() {
      this.CombinationBom = []
      this.$refs.dialog.close()
    },
    dateChange(data, row, type) {
      if (row.T !== 0) {
        row.T = 1
      }
      const date = this.$dayjs(data).valueOf()
      const startDate = this.$dayjs(row.StartTime).valueOf()
      if (date < startDate) {
        this.$message.warning(`${type == 'DocDate' ? '单据日期' : '预计完工日期'}需要大于等于开始日期, 请重新选择！`)
        row[type] = row.StartTime
        return
      }
    },

    editT(row) {
      if (row.T !== 0) {
        row.T = 1
      }
    },
    changeSchedulingType(val, row) {
      this.editT(row)
      if (val === 0) {
        row.DpId = 0
      } else if (val === 1) {
        row.MaintenanceId = 0
      }
    },
    base64ToFile(dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    async viewImg(row) {
      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg)
      const ImgUrl = res.Data
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！')
      let imgs = []
      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl))
        // imgs.push(imgBlob)
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs
      this.$refs.imgDialog.open()
    },
    viewImg2(row) {
      console.log(row, 'img2')
      let imgs = []
      row.PdImgs.forEach(item => {
        imgs.push('/api' + item.ImgUrl)
      })

      this.imgs = imgs
      this.$refs.imgDialog.open()
    },
    changeProcessType(val, row) {
      if (row.T !== 0) {
        row.T = 1
      }
      if (val === 0) {
        row.DpId = 0
      }
    },
    selectCome(row) {
      this.ProcessRow = row
      this.$refs.comeListDialog.open().then(that => {
        that.getData({ TradeUnitType: 3 })
      })
    },
    comeSelect(data) {
      console.log('data', data)
      this.ProcessRow.DpId = data.TradeUnitId
      this.ProcessRow.TradeUnitName = data.FullName
    },
    listDialogSelect(list) {
      let delProcessModels = JSON.parse(JSON.stringify(this.ProcessModels))
      console.log('delProcessModels', delProcessModels)
      if (delProcessModels[0].Processes.length !== 0 && delProcessModels[0].Processes[0].T !== 0) {
        delProcessModels[0].Processes.forEach(item => {
          item.T = 2
        })

        this.delProcess.push(...delProcessModels)

        console.log('delProcess', this.delProcess)
      }

      list.Processes.forEach(item => {
        item.ProcessType = null
        item.DpId = 0
        item.TradeUnitName = ''
      })

      this.currentProgrammeName = list.ProgrammeName
      this.ProcessModels[0].ProgrammeName = list.ProgrammeName
      this.ProcessModels[0].Processes = list.Processes
      this.ProcessModels[0].ProgrammeId = list.ProgrammeId
      this.CombinationBom[0].ProgrammeId = list.ProgrammeId

      let copyProcessModels = JSON.parse(JSON.stringify(this.ProcessModels))
      this.ProcessModels = []
      this.$nextTick(() => {
        this.ProcessModels = copyProcessModels
      })
    },
    detail_saved(list) {
      this.programmeCurrentRow.Processes = list
    },
    changeProgramme(row) {
      // this.programmeCurrentRow = row;
      this.$refs.listDialog.open()
    },
    changeProgrammeInfo(row) {
      this.programmeCurrentRow = row
      this.$refs.detailDialog.open().then(that => {
        that.setTableData(row)
      })
    },
    changeColor(val, row) {
      this.editT(row)
      let item = row.Colors.filter(item => {
        return item.ColorId === val
      })[0]

      row.ColorName = item.ColorName
    },
    changeProperty(val, row) {
      this.editT(row)
      let item = this.propertyList.filter(item => {
        return item.PropertyId === val
      })[0]

      row.PropertyName = item.PropertyName
    },
    changeQua(val, row, type) {
      this.editT(row)

      if (type == 1) {
        row.Quantity = parseFloat(val)
        this.DetailModels.forEach(item => {
          this.editT(item)
          item.Quantity = parseFloat((item.NeedQuantity * row.Quantity).toFixed(2))
        })
      } else {
        row.NeedQuantity = parseFloat((row.Quantity / this.CombinationBom[0].Quantity).toFixed(2))
        row.Quantity = parseFloat((val - 0).toFixed(2))
      }
    },
    onSelect(e, row, type = 0) {
      this.editT(row)
      row.ColorId = 0
      row.ProductName = e.ProductName
      row.ProductNo = e.ProductNo
      row.ProductSpec = e.ProductSpec
      row.ProcessStage = e.ProcessStage
      row.ProcessStageName = e.ProcessStageName
      row.ProduceTypeName = e.ProduceTypeName
      row.ProductId = e.ProductId
      this.selectProductId = e.ProductId
      row.Colors = e.Colors
      row.PdUnitName = e.PdUnitName
      row.PdUnitId = e.PdUnitId
      row.UseProcess = e.UseProcess
      row.UseColor = e.UseColor
      row.Mould = e.Mould
      row.MouldId = e.MouldId
      row.MouldName = e.MouldName
      row.ProductNature = e.ProductNature
      row.WarehousePositionList = []
      row.ProductionType = e.ProductNature ? (e.ProductNature == 2 ? 0 : 1) : e.ProductNature == 0 ? 0 : ''

      this.ProcessModels[0].ProductName = e.ProductName
      this.ProcessModels[0].ProductNo = e.ProductNo
      if (type === 1) {
        this.CombinationBom[0].Bomno = ''
        this.bomApi
          .dtsList({
            ProductName: e.ProductName,
            pageIndex: 1,
            pageSize: 10,
            IsDefault: true
          })
          .then(res => {
            if (res.Data.length > 0) {
              var boms = res.Data.filter(item => {
                return item.IsDefault == true
              })

              if (boms.length == 0) {
                var cBoms = res.Data.filter(x => {
                  return x.DetailModels.length > 0
                })
                row.Bomno = cBoms[0].Bomno

                row.TeImgs = cBoms[0].TeImgs
                this.CombinationBom[0].Bomno = cBoms[0].Bomno
                this.CombinationBom[0].TeProductId = cBoms[0].TeProductId
                this.CombinationBom[0].TeImgs = cBoms[0].TeImgs
                row.TeProductId = cBoms[0].TeProductId
                this.DetailModels = cBoms[0].DetailModels
                console.log('this.DetailModels', this.DetailModels)
              } else {
                row.TeImgs = boms[0].TeImgs
                row.Bomno = boms[0].Bomno
                row.TeProductId = boms[0].TeProductId
                this.CombinationBom[0].Bomno = boms[0].Bomno
                this.CombinationBom[0].TeProductId = boms[0].TeProductId
                this.CombinationBom[0].TeImgs = boms[0].TeImgs
                this.DetailModels = boms[0].DetailModels
              }
            }
            this.bomArr = res.Data
          })
      }
    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    presetFun() {
      this.ppageParams.pageIndex = 1
      this.pDAccount = this.pinitDAccount
      this.plistTotal = this.pinitTotal
    },
    currentPage({ val, text1 }) {
      this.pageParams.pageIndex = val
      this.pdApi.list({ pageIndex: val, pageSize: 7, Status: 1, ProductName: text1 }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data
          this.listTotal = res.Count
        }
      })
    },
    pcurrentPage({ val, text1 }) {
      this.ppageParams.pageIndex = val
      this.pdApi.list({ pageIndex: val, pageSize: 7, Status: 1, ProductName: text1 }).then(res => {
        if (res.Code == 0) {
          this.pDAccount = res.Data
          this.plistTotal = res.Count
        }
      })
    },
    inputText(text) {
      this.pdApi
        .list({
          //ProcessStages: [0, 1, 2],
          Status: 1,
          pageSize: this.pageParams.pageSize,
          pageIndex: this.pageParams.pageIndex,
          ProductName: text
        })
        .then(res => {
          if (res.Code === 0) {
            console.log('productApi res.Data', res.Data)
            this.DAccount = res.Data
            this.listTotal = res.Count
          }
        })
    },
    pinputText(text) {
      this.pdApi
        .list({
          ProcessStages: [this.Stage],
          Status: 1,
          pageSize: this.ppageParams.pageSize,
          pageIndex: this.ppageParams.pageIndex,
          ProductName: text
        })
        .then(res => {
          if (res.Code === 0) {
            console.log('productApi res.Data', res.Data)
            this.pDAccount = res.Data
            this.plistTotal = res.Count
          }
        })

      //  this.pdApi.list({pageIndex:1,pageSize:7 ,ProductName:text}).then((res) => {
      //       if (res.Code == 0) {
      //       this.pDAccount = res.Data;

      //       this.plistTotal=res.Count
      //       }
      //     });
    },
    add() {
      this.DetailModels.push({
        T: 0,
        WorkDocId: 0,
        WorkDocNo: '',
        WorkDocMaterialId: 0,
        ProductId: 0,
        ProductNo: '',
        ProductName: '',
        ProductSpec: '',
        BatchNumber: '',
        PdUnitId: 0,
        PdUnitName: '',
        Property: '',
        PropertyName: '',
        Quantity: 0,
        ImgUrl: '',
        ProcessStage: 0,
        ProduceTypeName: '',
        ColorId: 0,
        ColorName: '',
        Colors: [],
        UseProcess: true,
        UseColor: true,
        MouldNo: '',
        MouldId: 0,
        MouldName: '',
        Rate: 0,
        Loss: 0,
        Ration: 0,
        RationUnit: 0,
        OutWarehouseId: null,
        OutWarehousePositionId: null,
        WarehousePositionList: []
      })
    },
    del(row, index) {
      if (row.T !== 0) {
        row.T = 2
        this.delDetailModels.push(row)
      }
      this.DetailModels.splice(index, 1)
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday()
      var start = ''
      var end = ''
      switch (t) {
        case '今天':
          start = today
          end = today
          break
        case '昨天':
          start = this.$dayjs().subtract(1, 'day').format('YYYY-MM-DD')
          end = start
          break
        case '近3天':
          start = this.$dayjs().subtract(2, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '近7天':
          start = this.$dayjs().subtract(6, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '近14天':
          start = this.$dayjs().subtract(13, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '本周':
          start = this.$dayjs().startOf('week').format('YYYY-MM-DD')
          end = today
          break
        case '上周':
          var week = this.$dayjs().subtract(1, 'week')
          start = week.startOf('week').format('YYYY-MM-DD')
          end = week.endOf('week').format('YYYY-MM-DD')
          break
        case '本月':
          start = this.$dayjs().startOf('month').format('YYYY-MM-DD')
          end = today
          break
        case '上月':
          var month = this.$dayjs().subtract(1, 'month')
          start = month.startOf('month').format('YYYY-MM-DD')
          end = month.endOf('month').format('YYYY-MM-DD')
          break
        case '本季':
          start = this.$dayjs().startOf('quarter').format('YYYY-MM-DD')
          end = today
          break
        case '上季':
          var quarter = this.$dayjs().subtract(1, 'quarter')
          start = quarter.startOf('quarter').format('YYYY-MM-DD')
          end = quarter.endOf('quarter').format('YYYY-MM-DD')
          break
        case '本年':
          start = this.$dayjs().startOf('year').format('YYYY-MM-DD')
          end = today
          break
        case '上年':
          var year = this.$dayjs().subtract(1, 'year')
          start = year.startOf('year').format('YYYY-MM-DD')
          end = year.endOf('year').format('YYYY-MM-DD')
          break
      }

      return {
        start,
        end
      }
    },
    detailsOpened(data) {
      let _ProductModels = []
      let _ProcessModels = []
      let _MaterialModels = []
      let { MaterialModels, ProcessModels, ProductModels, ...rest } = data
      console.log('🚀 ~ detailsOpened ~ ProductModels:', ProductModels)

      let ProductName = ''
      let ProductNo = ''

      ProductModels.forEach(item => {
        ProductName = item.ProductName
        ProductNo = item.ProductNo

        // item.Pname = Pname;
        // item.Pno = Pno;

        rest.Property = rest.PropertyId ? rest.PropertyId : 0

        for (let i in rest) {
          if (!item.hasOwnProperty(i)) {
            // item[i] =  rest[i]
            this.$set(item, i, rest[i])
          }
        }
      })

      this.changetoNull(ProcessModels)

      let o = {
        ProductName,
        ProductNo,
        ProgrammeName: ProcessModels.length !== 0 ? ProcessModels[0].ProgrammeName : '',
        ProgrammeId: ProcessModels.length !== 0 ? ProcessModels[0].ProgrammeId : 0,
        Processes: ProcessModels
      }

      this.currentProgrammeName = ProcessModels.length !== 0 ? ProcessModels[0].ProgrammeName : ''

      MaterialModels.forEach(item => {
        item.Pno = item.ProductNo
        item.Pname = item.ProductName
        item.PdUnitName = item.UnitName
        item.PdUnitId = item.QuantityUnit
        item.NeedQuantity = parseFloat((item.Quantity / ProductModels[0].Quantity).toFixed(2))
        item.Property = item.PropertyId ? item.PropertyId : 0
      })

      _ProductModels.push(...ProductModels)
      _ProcessModels.push(o)
      _MaterialModels.push(...MaterialModels)

      this.changetoNull(_ProductModels)
      this.changetoNull(_MaterialModels)

      this.CombinationBom = _ProductModels
      this.ProcessModels = _ProcessModels
      this.DetailModels = _MaterialModels
      this.Status = data.Status
    },
    changetoNull(data) {
      data.forEach(item => {
        item.T = null
      })
    },
    filterData(data) {
      return data.filter(item => {
        return item.T != null
      })
    },
    onPrint() {
      if (this.$parent.orderType == '已下达') {
        this.toPrint(this.CombinationBom[0].WorkDocId)
      } else if (this.$parent.orderType == '日生产') {
        this.toPrint(this.CombinationBom[0].WorkDocId)
      }
    },
    toPrint(id) {
      let newpage = this.$router.resolve({
        path: '/workorderPrint?id=' + id + '&t=' + this.Stage + '&name=' + this.StageName
      })
      window.open(newpage.href, '_blank')
    },
    save() {
      if (this.CombinationBom[0].Quantity == 0) return this.$message({ type: 'warning', message: '需求数量不能为0' })

      if (this.CombinationBom[0].PickingWarehouseId == null) {
        this.$message({ type: 'warning', message: '领料仓库不能为空' })
        return
      }
      if (this.CombinationBom[0].ProductionType == 0 && !this.CombinationBom[0].DpId) return this.$message({ type: 'warning', message: '请选择生产部门' })
      else if (this.CombinationBom[0].ProductionType == 1 && !this.CombinationBom[0].ProductionDpId) return this.$message({ type: 'warning', message: '请选择加工商' })

      if (!this.QuickProcess) {
        if (this.CombinationBom[0].SchedulingType == null)
          return this.$message({
            type: 'warning',
            message: '产品明细的排产类型需必选'
          })
        if (this.CombinationBom[0].ProductionType !== 0 && this.CombinationBom[0].SchedulingType == 0 && (this.CombinationBom[0].DpId == null || this.CombinationBom[0].DpId == 0)) {
          return this.$message({ type: 'warning', message: '部门不能为空' })
        }
        if (this.CombinationBom[0].ProductionType !== 0 && this.CombinationBom[0].SchedulingType == 1 && (this.CombinationBom[0].MaintenanceId == null || this.CombinationBom[0].MaintenanceId == 0)) {
          return this.$message({ type: 'warning', message: '设备不能为空' })
        }
      }
      if (!this.IsSelfPicking) {
        if (this.CombinationBom[0].ProductionType == 0) {
          var len = this.DetailModels
          console.log('len', len)
          for (var i = 0; i < len; i++) {
            var detailModel = this.DetailModels[i]
            if (detailModel.OutWarehouseId > 0) {
            } else {
              return this.$message({ type: 'warning', message: '启用自制工单不领料，预出仓不能为空' })
            }
          }
        }
      }
      if (this.CombinationBom[0].ProductionType !== 0 && this.CombinationBom[0].ProductionDpId == null) {
        return this.$message({ type: 'warning', message: '供应商不能为空' })
      }

      // if (this.CombinationBom[0].ProgrammeId != 0 || this.CombinationBom[0].ProgrammeId != null) {
      //   if (this.ProcessModels[0].Processes.length == 0 && !this.QuickProcess) {
      //     return this.$message({
      //       type: 'warning',
      //       message: '方案详情不能为空'
      //     })
      //   }
      //   let pLen = this.ProcessModels[0].Processes.length
      //   for (var i = 0; i < pLen; i++) {
      //     var process = this.ProcessModels[0].Processes[i]
      //     if (process.ProcessId == 0) {
      //       return this.$message({ type: 'warning', message: '工序不能为空' })
      //     }
      //     if (process.ProcessType == null) {
      //       return this.$message({
      //         type: 'warning',
      //         message: '工序类型不能为空'
      //       })
      //     }
      //     if (process.ProcessType == 1 && (process.DpId == null || process.DpId == 0)) {
      //       return this.$message({
      //         type: 'warning',
      //         message: '委外供应商不能为空'
      //       })
      //     }
      //   }
      // }
      let ProductModels = []
      let ProcessModels = []
      let MaterialModels = []
      this.CombinationBom.forEach(item => {
        let o = {
          T: item.T,
          WorkDocProductId: item.WorkDocProductId,
          WorkDocId: item.WorkDocId,
          ProductId: item.ProductId,
          PdUnitId: item.PdUnitId,
          ProgrammeId: item.ProgrammeId,
          ColorId: item.ColorId,
          Quantity: item.Quantity,
          SourceDtsId: 0,
          RpType: item.ProcessStage,
          RpRequirement: '',
          SnType: 0,
          Loss: 0,
          Status: 0,
          WorkDocNo: item.WorkDocNo,
          TeProductId: item.TeProductId,
          PdImgs: item.PdImgs
        }
        ProductModels.push(o)
      })

      this.ProcessModels[0].Processes.forEach(item => {
        let o = {
          T: item.T,
          ProgrammeId: item.ProgrammeId,
          ProcessType: item.ProcessType,
          DpId: item.DpId,
          WorkDocProcessId: item.WorkDocProcessId ?? 0,
          WorkDocId: this.CombinationBom[0].WorkDocId,
          ProcessId: item.ProcessId,
          ProcessSn: item.ProcessSn,
          SnType: item.SnType ?? 0,
          ConvertRatio: item.ConvertRatio ?? 1,
          MachineId: item.MachineId ?? 0,
          Length: item.Length ?? 0,
          Width: item.Width ?? 0,
          Multiple: item.Multiple ?? 0,
          RatedLoss: item.RatedLoss ?? 0,
          LossRate: item.LossRate ?? 0,
          PlanIn: item.PlanIn ?? 0,
          PlanOut: item.PlanOut ?? 0,
          PlanOutUnit: item.PlanOutUnit ?? '',
          Requirement: item.Requirement ?? '',
          Status: item.Status ?? 0
        }
        ProcessModels.push(o)
      })

      this.delProcess[0]?.Processes.forEach(item => {
        let o = {
          T: 2,
          ProgrammeId: item.ProgrammeId,
          ProcessType: item.ProcessType,
          DpId: item.DpId ?? 0,
          WorkDocProcessId: item.WorkDocProcessId ?? 0,
          WorkDocId: item.WorkDocId ?? 0,
          ProcessId: item.ProcessId,
          ProcessSn: item.ProcessSn,
          SnType: item.SnType ?? 0,
          ConvertRatio: item.ConvertRatio ?? 1,
          MachineId: item.MachineId ?? 0,
          Length: item.Length ?? 0,
          Width: item.Width ?? 0,
          Multiple: item.Multiple ?? 0,
          RatedLoss: item.RatedLoss ?? 0,
          LossRate: item.LossRate ?? 0,
          PlanIn: item.PlanIn ?? 0,
          PlanOut: item.PlanOut ?? 0,
          PlanOutUnit: item.PlanOutUnit ?? '',
          Requirement: item.Requirement ?? '',
          Status: item.Status ?? 0
        }
        ProcessModels.push(o)
      })

      this.DetailModels.forEach(item => {
        let o = {
          T: item.T,
          WorkDocMaterialId: item.WorkDocMaterialId,
          WorkDocId: item.WorkDocId,
          ProductId: item.ProductId,
          ColorId: item.ColorId,
          Ration: item.Ration,
          RationUnit: item.RationUnit,
          Quantity: item.Quantity,
          QuantityUnit: item.PdUnitId,
          PropertyId: item.Property,
          Rate: item.Rate,
          Loss: item.Loss,
          OutWarehouseId: item.OutWarehouseId,
          OutWarehousePositionId: item.OutWarehousePositionId
        }
        MaterialModels.push(o)
      })

      let {
        WorkDocId,
        WorkDocNo,
        SchedulingType,
        DpId,
        MaintenanceId,
        ProductionType,
        ProductionDpId,
        DocDate,
        StartTime,
        EndTime,
        Remark = '',
        PickingWarehouseId,
        PickingWarehousePositionId
      } = this.CombinationBom[0]
      if (DpId == null) {
        DpId = 0
      }
      if (MaintenanceId == null) {
        MaintenanceId = 0
      }
      // let {start} = this.cycleChange('今天')
      let data = {
        Stage: this.Stage,
        WorkDocType: 0,
        ProductType: 0,
        // StartTime: start,
        WorkDocId,
        WorkDocNo,
        EndTime,
        SchedulingType,
        DpId,
        MaintenanceId,
        ProductionType,
        ProductionDpId,
        DocDate,
        StartTime,
        Remark,
        PickingWarehouseId,
        PickingWarehousePositionId
      }

      ProcessModels.forEach(item => {
        if (item.WorkDocProcessId > 0) {
          if (item.T !== 2) {
            item.T = 1
          }
        } else {
          item.T = 0
        }
      })

      MaterialModels = MaterialModels.concat(this.delDetailModels)

      ProductModels = this.filterData(ProductModels)
      ProcessModels = this.filterData(ProcessModels)
      MaterialModels = this.filterData(MaterialModels)
      if (MaterialModels.some(item => JSON.stringify(item.Quantity) == 'null' || item.Quantity === '')) {
        this.$message({ type: 'warning', message: '子件需求数量未填写' })
        return
      }

      let o = {
        ProductModels,
        ProcessModels,
        MaterialModels,
        ...data
      }

      let WorkDocModels = []
      WorkDocModels.push(o)

      let saveData = {
        WorkDocModels
      }
      if (!saveData.WorkDocModels[0].StartTime) {
        this.$message.warning('请填写开始日期！')
        return
      }
      if (!saveData.WorkDocModels[0].DocDate) {
        this.$message.warning('请填写单据日期！')
        return
      }
      if (!saveData.WorkDocModels[0].EndTime) {
        this.$message.warning('请填写预计完工日期！')
        return
      }
      if (this.$dayjs(saveData.WorkDocModels[0].StartTime).valueOf() > this.$dayjs(saveData.WorkDocModels[0].DocDate).valueOf()) {
        this.$message.warning('开始日期需要小于单据日期，请重新选择！')
        return
      }
      if (this.$dayjs(saveData.WorkDocModels[0].StartTime).valueOf() > this.$dayjs(saveData.WorkDocModels[0].EndTime).valueOf()) {
        this.$message.warning('开始日期需要小于预计完工日期，请重新选择！')
        return
      }
      console.log('saveData', saveData)
      var loading = this.$loading({
        lock: true,
        text: '正在查询...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      this.api
        .save(saveData)
        .then(res => {
          loading.close()
          if (res.Code === 0) {
            console.log('res.Data', res.Data)
            this.$emit('saved')
            this.close()
            this.$message({ type: 'success', message: '操作成功' })
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.div {
  margin: 18px 0;
}
.flex {
  display: flex;
}

.mr8 {
  margin-right: 8px;
}
.flex1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 6px 0;
}
.flex2 {
  display: flex;
}
.flex-content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 6px 0;
}
</style>
